import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

declare module '@ngx-translate/core/lib/translate.service' {
	interface TranslateService {
		streamMany<Keys extends string>(keys: Keys[], interpolateParams?: Record<string, unknown>): Observable<Record<Keys, string>>;
		getMany<Keys extends string>(keys: Keys[], interpolateParams?: Record<string, unknown>): Observable<Record<Keys, string>>;
		instantMany<Keys extends string>(keys: Keys[], interpolateParams?: Record<string, unknown>): Record<Keys, string>;
	}
}

TranslateService.prototype.streamMany = TranslateService.prototype.stream;
TranslateService.prototype.getMany = TranslateService.prototype.get;
TranslateService.prototype.instantMany = TranslateService.prototype.instant;